const state = {
  config: {},
  // 上次更新时间
  _updatedAt: ''
}
export default state
